var InFlight = InFlight || {};

InFlight.Events = (function() {
  var lastInterval;

  var processTimeLeft = function() {
    // in a timeout because we want it to fire only after afterProcessResponse is done
    setTimeout(function() {
      var handleTimeLeft = function($el, result) {
        if (!result) {
          $el.text('');
          return;
        }
        var timeLeft = result.timeLeft;
        $el.addClass('bold');
        $el.removeClass('text-danger');
        $el.removeClass('text-warning');
        if (timeLeft !== undefined) {
          if (timeLeft > 0) {
            $el.text($.i18n('_due_in') + ' ' + formatTimeDiff(timeLeft));
            $el.addClass('text-danger');
            $el.attr('time-left', '' + timeLeft);
          }else if(!result.status){
            $el.removeAttr('time-left');

            $el.text($.i18n('events_search_event_completed'));
          }          
        }
        if (result.status) {
          $el.text(result.status);
        }
      };

      var initTimeLeftSrcCalls = function() {

        $('[time-left-src]:in-viewport').each(function() {
          var $this = $(this);
          var timeLeftSrc = $this.attr('time-left-src');
          $this.removeAttr('time-left-src');
          getTimeLeft(timeLeftSrc, function(timeLeft) {
            handleTimeLeft($this, timeLeft);
          });
        });
      }

      initTimeLeftSrcCalls();

      window.addEventListener('scroll', _.throttle(initTimeLeftSrcCalls, 500));

      var POLL_TIME = 1000;
      if (lastInterval) {
        clearInterval(lastInterval);
      }
      lastInterval = setInterval(function() {
        var $tl = $('[time-left]');

        $tl.each(function() {
          var $this = $(this);
          var timeLeft = parseInt($this.attr('time-left')) - POLL_TIME;
          handleTimeLeft($this, { timeLeft: timeLeft });
        });
      }, POLL_TIME);
    });
  };

  function formatTimeDiff(diff) {
    // taken from PeopleSoft
    var minPerDay = 60 * 1000;
    var hoursPerDay = 60 * 60 * 1000;

    var secsLeft = diff / minPerDay;
    var secsRound = Math.round(secsLeft);
    var secsRemain = secsLeft - secsRound;
    secsRemain =
      secsRemain < 0
        ? (secsRemain = 60 - (secsRound - secsLeft) * 60)
        : (secsRemain = (secsLeft - secsRound) * 60);
    secsRemain = Math.round(secsRemain - 0.495);

    var minLeft = diff / hoursPerDay;
    var minRound = Math.round(minLeft);
    var minRemain = minLeft - minRound;
    minRemain =
      minRemain < 0
        ? (minRemain = 60 - (minRound - minLeft) * 60)
        : (minRemain = (minLeft - minRound) * 60);
    minRemain = Math.round(minRemain - 0.495);

    var hoursLeft = diff / hoursPerDay;
    var hoursRemain = Math.round(hoursLeft - 0.5);
    if (hoursRemain < 10) hoursRemain = '' + hoursRemain;
    if (minRemain < 10) minRemain = '' + minRemain;
    if (secsRemain < 10) secsRemain = '' + secsRemain;
    if (hoursRemain == 1) hoursRemain = hoursRemain + '' + 'hr,' + '';
    else hoursRemain = hoursRemain + '' + 'hrs,' + '';
    if ('True' == 'True') {
      if (minRemain == 1) minRemain = minRemain + '' + 'min,' + '';
      else minRemain = minRemain + '' + 'mins,' + '';
      if (secsRemain == 1) secsRemain = secsRemain + '' + 'sec' + '';
      else secsRemain = secsRemain + '' + 'secs';
    } else {
      if (minRemain == 1) minRemain = minRemain + '' + 'min';
      else minRemain = minRemain + '' + 'mins';
    }

    var timeRemain = hoursRemain + minRemain;

    timeRemain = timeRemain + secsRemain;

    return timeRemain;
  }

  function getTimeLeft(targetUrl, cb) {
    var extractDate = function(prefix, html, regex) {
      var matches = regex.exec(html);
      if (matches) {
        var year = parseInt(matches[1]);
        var month = parseInt(matches[2]);
        var day = parseInt(matches[3]);
        var hour = parseInt(matches[4]);
        var minute = parseInt(matches[5]);
        var second = parseInt(matches[6]);
        return new Date(year, month, day, hour, minute, second);
      }
    };

    var config = {
      targetUrl: targetUrl,
      followProposedTemplate: false,
      showLoading: false,
      manualRequestObj: [
        {
          Lbl: 'body',
          Src: 'body',
          Data: 'html'
        },
        {
          Lbl: 'span',
          Src: 'body > span',
          Data: 'text'
        }
      ],
      callback: function(data) {
        var html = data.CaptureResults.body[0].Properties.html;
        var expires = extractDate(
          'today',
          html,
          /today[0-9]+\s*= new Date\(([0-9]+),\s*([0-9]+),\s*([0-9]+),\s*([0-9]+),\s*([0-9]+),\s*([0-9]+)\s*\)/
        );
        var now = extractDate(
          'count',
          html,
          /count[0-9]+\s*= new Date\(([0-9]+),\s*([0-9]+),\s*([0-9]+),\s*([0-9]+),\s*([0-9]+),\s*([0-9]+)\s*\)/
        );
        if (expires && now) {
          var timeLeft = now.getTime() - expires.getTime();
          if (cb) {
            cb({ timeLeft: timeLeft });
            return;
          }
        } else {
          if (
            data.CaptureResults.span &&
            data.CaptureResults.span.length === 1
          ) {
            var spanText = data.CaptureResults.span[0].Properties.text;
            if (spanText) {
              cb({ status: spanText });
              return;
            }
          }
        }
        if (cb) {
          cb();
        }
      }
    };
    var winNum = 1;
    config.targetUrl = targetUrl.replace(
      '/' + InFlight.NLX.Cfg.Customer.getPsPortalBaseName() + '/',
      '/' + InFlight.NLX.Cfg.Customer.getPsPortalBaseName() + '_' + winNum + '/'
    );

    var InFlightPSHelper = new InFlightDCType();
    InFlightPSHelper.init(config);
  }

  return {
    processTimeLeft: processTimeLeft
  };
})();
